import { PopoverContainerUi, PopoverHeader, PrimaryButton } from "ui";
import HundredMsTelePlatform from "./100-ms-platform";
import EkaTelePlatform from "./eka-platform";
import OtherTelePlatform from "./other-platform";
import { useMemo, useState } from "react";
import useTeleConfigurationStore from "../../../../../stores/vc-meta-store";
import useQueueStore from "../../../../../stores/queue-store";
import { SupportedTeleProviders } from "@elixir/types";
type LinkType = "100ms" | "general";

function TelePlatformsPopover() {
  return (
    <PopoverContainerUi className="dr-max-h-500 dr-min-h-300 dr-overflow-y-hidden dr-max-w-408 dr-w-408 dr-flex dr-flex-col">
      <div className="dr-flex dr-flex-col dr-h-full dr-flex-1">
        <PopoverHeader onCloseClick={() => {}} title="Video Call Platform" />
        <form className="px-16 py-8 dr-flex-1 dr-flex dr-flex-col dr-justify-between">
          <div>
            <EkaTelePlatform />
            <HundredMsTelePlatform />
            <OtherTelePlatform />
          </div>
          <TelePlatformSubmitButton />
        </form>
      </div>
    </PopoverContainerUi>
  );
}

function TelePlatformSubmitButton() {
  const platform = useTeleConfigurationStore((state) => state.platform);
  const meetLink = useTeleConfigurationStore((state) => state.meetLink);
  const hostLink = useTeleConfigurationStore((state) => state.hostLink);
  const setShowTeleConfigurationPopup = useTeleConfigurationStore(
    (state) => state.setShowTeleConfigurationPopup
  );

  const setVcMeta = useQueueStore((state) => state.setVcMeta);

  const isValid100msUrl = (url: string): boolean => {
    try {
      const parsed = new URL(url);
      return parsed.hostname.endsWith(".100ms.live");
    } catch {
      return false;
    }
  };

  const isValidGeneralUrl = (url: string): boolean => {
    const regex = /^(https?:\/\/)([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/i;
    return regex.test(url);
  };

  const isValidUrl = (url: string, type: LinkType = "general"): boolean => {
    if (!url) return false;
    return type === "100ms" ? isValid100msUrl(url) : isValidGeneralUrl(url);
  };

  const isValid = useMemo(() => {
    if (platform === SupportedTeleProviders.eka) {
      return true;
    } else if (platform === SupportedTeleProviders["100MS"]) {
      return (
        isValidUrl(meetLink || "", "100ms") &&
        isValidUrl(hostLink || "", "100ms")
      );
    } else if (platform === SupportedTeleProviders.other) {
      return isValidUrl(meetLink || "", "general");
    }

    return false;
  }, [platform, meetLink, hostLink]);

  return (
    <div className="dr-px-14 dr-w-full dr-pt-12 dr-py-24">
      <PrimaryButton
        title="Submit"
        isDisabled={!isValid}
        onClick={(e) => {
          e.preventDefault();
          //commit to queue store.
          setVcMeta({ platform, host_link: hostLink, meet_link: meetLink });
          setShowTeleConfigurationPopup({ showTeleConfigurationPopup: false });
        }}
        size="large"
        extraClass="dr-w-full"
      />
    </div>
  );
}

export default TelePlatformsPopover;
